export const confirm = ({ form, user }) => {
    form.setConfig({
        "title": "Confirmation",
        "location": `FlightTestCrew/${user.ID}`,
        "type": "update",
        "submitButtonText": "Confirm",
        "submitButtonClass": "bg-green-500 hover:bg-green-700",
        "fields": [{
            "label": "Terms and Conditions",
            "type": "value",
            "grow": true,
            "divClass": "md:col-span-3",
            value() {
                return `<p>By accessing and using this system, you agree to the following terms and conditions regarding the processing of your data:</p>
                        <br/>
                        <ol>
                            <li>All data provided by the user shall be processed in accordance with applicable data protection laws and regulations.</li>
                            <li>The user consents to the collection, storage, and processing of their data for the purpose of providing the services offered by the system.</li>
                            <li>The user has the right to request access to, rectification, or erasure of their personal data held by the system.</li>
                            <li>The system will take appropriate measures to ensure the security and confidentiality of the user's data.</li>
                            <li>The user's data may be transferred to third parties only with their explicit consent or as required by law.</li>
                            <li>The user agrees to indemnify the system against any claims arising from the processing of their data.</li>
                        </ol>
                        <br/>
                    `
            }
        }],
        preSubmitHook() {
            return {
                "Completed": true,
                "Concent": true,
                "Date": {
                    "Confirmation": new Date().toISOString(),
                    "Completed": new Date().toISOString()
                }
            };
        }
    });

    form.toggle();
};

export const revokeConfirmation = ({ form, user }) => {
    form.setConfig({
        "title": "Revoke Confirmation",
        "location": `FlightTestCrew/${user.ID}`,
        "type": "update",
        "fields": [{
            "label": "Reason for Revocation",
            "key": "reason",
            "type": "textarea",
            "required": true
        }],
        preSubmitHook() {
            return {
                "Completed": false,
                "Concent": false,
                "Date": {
                    "Confirmation": "N/A",
                    "Completed":  "N/A"
                }
            };
        }
    });

    form.toggle();
};
